<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      红岭南站<br>
站点介绍<br>
红岭南站位于深南东路与红岭南路交叉路口的东南侧，沿着红岭南路南北方向布置。西端有红岭南路，深南中路，红岭中路；附件有红岭大厦，万德大厦，新闻大厦，邓小平画像，荔枝公园；东端是金华街，丽晶大厦；北端是深南东路，书城路，深圳书城，靠近金融中心大厦。红岭南站以蓝色为基调，装修风格为梅香客韵。站厅两侧与全线标准统一材料、规格、安装形式，立柱之间区域，采用格栅形式突出重点。通过站厅、站台地面节奏线造型、站台的与导向共性元素结合的座椅等元素以及天花强调功能的裸露形式，呼应和谐主题，整个空间协调统一。为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:27	23:07	9号线	3分50秒	5分55秒<br>
文锦	06:20	00:01	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:27	23:07	9号线	4分25秒	5分55秒<br>
文锦	06:19	00:01	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:27	00:07	9号线	4分钟	5分55秒<br>
文锦	06:17	01:01	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
红岭南路、深南中路、红岭中路、邓小平画像、荔枝公园、红岭大厦、万德大厦、新闻大厦<br><br>
C出入口:<br>
金华街、晶都大厦、深圳平乐骨伤科医院<br><br>
D出入口:<br>
深南东路、金塘街、书城路、金融中心大厦、深业中心<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 红岭南路1<br>
M401路、M463路、M559路、N10路、8路、29路、63路、75路、214路、E25路、14路、M482路<br><br>
C出入口:<br>
公交站名： 红岭南路2<br>
14路、M401路<br><br>
D出入口:<br>
公交站名： 深圳书城<br>
M559路、N4路、29路、85路、103路、104路、113路、204路、215路、M106路、M112路、M133路<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>